// @flow
import {
    SET_LEFT_MENU_STATUS,
    SET_NOTIFICATION,
    SET_PAYMENT_CONTACT,
    SET_PAYMENT_DASHBOARD_STATUS,
    SET_PAYMENT_HOSTED_ROOM,
    SET_PAYMENT_INVITATION_ROOM,
    SET_PAYMENT_INVITED_ROOM,
    SET_PAYMENT_SELECTED_PAGE,
    SET_WINDOW_REF,
    SET_USER_SUBSCRIPTION,
    SET_TIMEZONES,
    SET_INVITION_NOTIFICATION_COUNT,
    SHOW_PAYMENT_DASHBOARD,
    SET_AVAILABLE_SUB_PACKAGE,
    SET_PAID_ROOM_HISTORY,
    SET_SUBSCRIPTION_PAYMENT_HISTORY
} from "./actionType"


export function setWillShowDashboard(willShowPaymentDashboard: Boolean) {
    return {
        type: SET_PAYMENT_DASHBOARD_STATUS,
        willShowPaymentDashboard
    }
}
export function setPaymentSelectedPage(paymentSelectedPage: String, paymentId: string = "", additionalPageDetail: any) {
    return {
        type: SET_PAYMENT_SELECTED_PAGE,
        paymentSelectedPage,
        paymentId,
        additionalPageDetail
    }
}
export function setLeftMenuStatus(isLeftMenuOpen: Boolean) {
    return {
        type: SET_LEFT_MENU_STATUS,
        isLeftMenuOpen

    }
}

export function setHostedRoom(paymentHostedRoom: any) {
    return {
        type: SET_PAYMENT_HOSTED_ROOM,
        paymentHostedRoom
    }
}
export function setPaymentContact(paymentContact: any) {
    return {
        type: SET_PAYMENT_CONTACT,
        paymentContact
    }
}
export function setPaymentInvitedRoom(paymentInvitedRoom: any) {
    return {
        type: SET_PAYMENT_INVITED_ROOM,
        paymentInvitedRoom
    }
}
export function setPaymentInvitationRoom(paymentInvitationRoom: any) {
    return {
        type: SET_PAYMENT_INVITATION_ROOM,
        paymentInvitationRoom
    }
}

export function setNotificationMessage(notificationMessage: any) {
    return {
        type: SET_NOTIFICATION,
        notificationMessage
    }
}
// fix me : we are holding window.open reference in store to close the window at any page
export function setWindowReference(windowRef: any) {

    // console.log("setWindowReference ", windowRef);

    return {
        type: SET_WINDOW_REF,
        windowRef
    }
}

export function setUserPackageSubscription(userPaymentSubscription: any) {

    // console.log("user subscription ", userPaymentSubscription);

    return {
        type: SET_USER_SUBSCRIPTION,
        userPaymentSubscription
    }
}

export function setTimezones(timezones: array) {
    return {
        type: SET_TIMEZONES,
        timezones
    }
}
export function setPaymentInvitationCount(paymentPendingInvition: Number) {
    return {
        type: SET_INVITION_NOTIFICATION_COUNT,
        paymentPendingInvition
    }
}

// To show/hide the payment dashboard
export function showPaymentDashboard(isShowPaymentDashboard: Boolean) {
    return {
        type: SHOW_PAYMENT_DASHBOARD,
        isShowPaymentDashboard
    }
}

export function setSubscriptionPackage(subscriptionPackageList: Object) {
    // console.log("subscriptionPackageList", subscriptionPackageList)
    return {
        type: SET_AVAILABLE_SUB_PACKAGE,
        subscriptionPackageList
    }
}

export function setPaidRoomPaymentHistory(paidRoomHistory: any) {
    // console.log("paid room history", paidRoomHistory);
    return {
        type: SET_PAID_ROOM_HISTORY,
        paidRoomHistory
    }
}

export function setSubscriptionPaymentHistory(subscriptionPaymentHistory: any) {
    // console.log("subscriptionPaymentHistory", subscriptionPaymentHistory);
    return {
        type: SET_SUBSCRIPTION_PAYMENT_HISTORY,
        subscriptionPaymentHistory
    }
}